export default {
    cardWidth: 310,
    cardHeight: 92,
    cardHeaderHeight: 40,
};
